import { render, staticRenderFns } from "./SingleInvoices.vue?vue&type=template&id=063d7e02&"
import script from "./SingleInvoices.vue?vue&type=script&lang=js&"
export * from "./SingleInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleInvoices.vue"
export default component.exports